import { AssetsResponse, SelectedFilters } from '@interfaces'
import { api } from '@utils/api/api'
import { buildQueryParams } from '@utils/helpers'

export const getAssets = (
  query = '',
  page = 0,
  assetTypes = '',
  selectedFilters: SelectedFilters = {},
  sortBy: string,
  ter: string,
): Promise<AssetsResponse> => {
  let filters: SelectedFilters = {
    page: page.toString(),
    query,
  }

  if (sortBy) {
    filters = {
      ...filters,
      sortBy,
    }
  }

  if (ter) {
    filters = {
      ...filters,
      ter,
    }
  }

  if (assetTypes) {
    filters = {
      ...filters,
      assetTypes,
    }
  }

  if (selectedFilters) {
    filters = {
      ...filters,
      ...selectedFilters,
    }
  }

  const params = buildQueryParams(filters)

  return api.get(
    `api/v2/mobile/assets${Object.keys(filters)?.length ? params : ''}`,
  )
}
